module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAj0lEQVQ4y2NgGBwgy+8/WZgmBigk+fxfaef6/6O24/93Oo7/l9i7/pdK9iXOAO503/9XjJz/f9FyRMFnTJ3/s2UQYUCWnweGZhiODPYkbECXmztOA6q93AkbkBLgidOAMGJcwAn053kTzDA4bO5CXBiAMCjEQSH/TM/p/2N9p/+zHd3+i6T60jEdkGfAkAYA+h0honrw4/4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/BD.png
// module id = 1086
// module chunks = 0